<template>
  <div
    class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 dark:bg-background min-h-screen"
  >
    <div class="mb-8 flex flex-col items-center justify-center">
      <h1 class="text-[40px] text-foreground mb-2 text-center">
        Choose a plan that suits your learning needs
      </h1>
      <p class="text-[20px] text-muted-foreground text-center">
        Learn and explore new opportunities today!
      </p>
    </div>

    <!-- <div class="max-w-md mx-auto mb-12">
      <Input placeholder="Search for a plan..." class="w-full" />
    </div> -->

    <PricingComponent />
  </div>
</template>

<script>
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);
import PricingComponent from "@/components/pricing/PricingComponent.vue";
// import { Input } from "@/components/ui/input";

export default {
  name: "FeedsView",
  components: {
    PricingComponent,
    // Input,
  },
  data() {
    return {
      newPost: "",
    };
  },
  computed: {},
  methods: {},
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
/* Additional styles if needed */
</style>
